import {t} from "@lingui/core/macro";
import type {CSSProperties} from "aphrodite";
import * as React from "react";

import {OptionItem, SingleSelect} from "@khanacademy/wonder-blocks-dropdown";

import type {CourseType} from "./types.ts";

type CourseOptions = Array<{
    text: string;
    value: CourseType | "All";
}>;

interface Props {
    selectedCourseFilter: CourseType | null | undefined;
    handleCourseFilterChange: (value?: CourseType | null | undefined) => void;
    style?: CSSProperties;
    includeKmap: boolean;
}

const courseOptions: () => Array<{
    value: CourseType | "All";
    text: string;
}> = () => {
    return [
        {
            value: "All",
            text: t`All content`,
        },
        {
            value: "KMAP",
            text: t`Learning Paths instructional areas`,
        },
        {
            value: "CourseMastery",
            text: t`Course mastery goals`,
        },
    ];
};

const getCourseFilter = (
    availableCourseOptions: CourseOptions,
    selection: string,
): CourseType | null | undefined => {
    const courseFilter = availableCourseOptions.find(
        ({value}) => value === selection,
    );
    return !courseFilter || courseFilter.value === "All"
        ? null
        : courseFilter.value;
};

const ActivitySessionsCourseSelect = (props: Props): React.ReactElement => {
    const {selectedCourseFilter, handleCourseFilterChange, style, includeKmap} =
        props;

    return (
        <SingleSelect
            aria-label={t`Course type`}
            selectedValue={selectedCourseFilter || "All"}
            onChange={(value: string) => {
                handleCourseFilterChange(
                    getCourseFilter(courseOptions(), value),
                );
            }}
            style={style}
            placeholder=""
            testId="course-type-filter"
        >
            {courseOptions()
                .filter(({value}) => filterKmapPredicate(includeKmap, value))
                .map(({value, text}) => (
                    <OptionItem key={value} value={value} label={text} />
                ))}
        </SingleSelect>
    );
};

const filterKmapPredicate = (
    includeKmap: boolean,
    value: "All" | CourseType,
) => {
    return (includeKmap && value === "KMAP") || value !== "KMAP";
};

export default ActivitySessionsCourseSelect;
